var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mr-2",attrs:{"icon":"","color":"error"}},[_c('v-icon',[_vm._v(" mdi-close ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }